import { Global } from 'constants/index';
import { useEffect, useState } from 'react';
import { supportedLanguages } from 'utils/i18n';

const useReportLanguage = () => {
  const [ lang, setLang ] = useState(supportedLanguages.FI.abrevation);
  const [ isReady, setIsReady ] = useState(false);
  useEffect(() => {
    const localStorageLang = localStorage.getItem(Global.REPORT_LANG);
    if (localStorageLang && Object.values(supportedLanguages).some(l => l.abrevation === localStorageLang)) {
      setLang(localStorageLang);
    }
    setIsReady(true);
  }, []);

  const setLanguage = (lang : string) => {
    setLang(lang);
    localStorage.setItem(Global.REPORT_LANG, lang);
  };

  return { lang, setLanguage, isReady };
};

export { useReportLanguage };